import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import { useAppData } from '../../context/AppContext';

export default function WatchlistSidebar({ activeId, setActiveId }) {
  const { watchlists, saveWatchlist, deleteWatchlist } = useAppData();
  const [isCreating, setIsCreating] = useState(false);
  const [newName, setNewName] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState('');

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    const newList = { name: newName.trim(), instruments: [] };
    const saved = await saveWatchlist(newList);
    if (saved) {
      setActiveId(saved.id);
      setNewName('');
      setIsCreating(false);
    }
  };

  const handleRename = async (list, e) => {
    e.preventDefault();
    if (!editName.trim()) return;
    await saveWatchlist({ ...list, name: editName.trim() });
    setEditingId(null);
  };

  const startRename = (list, e) => {
    e.stopPropagation();
    setEditingId(list.id);
    setEditName(list.name);
  };

  const handleDelete = (id, e) => {
    e.stopPropagation();
    if (confirm('Delete this watchlist? This will remove all instruments inside it.')) {
      deleteWatchlist(id);
      if (activeId === id) setActiveId(null);
    }
  };

  return (
    <div className="w-64 border-r border-app-border bg-app-surface/50 flex flex-col h-full">
      <div className="p-6 border-b border-app-border flex justify-between items-center bg-app-surface">
        <h3 className="font-black text-[10px] text-app-accent uppercase tracking-[0.3em]">Watchlists</h3>
        <button 
          onClick={() => setIsCreating(true)} 
          className="text-app-accent hover:text-white p-1.5 transition-all bg-app-accent/5 rounded-lg border border-app-accent/10" 
          title="New Watchlist"
        >
          <FiIcons.FiPlus size={20} />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-2">
        {isCreating && (
          <form onSubmit={handleCreate} className="mb-4">
            <input 
              autoFocus 
              type="text" 
              value={newName} 
              onChange={(e) => setNewName(e.target.value)} 
              onBlur={() => !newName && setIsCreating(false)} 
              placeholder="List Name..." 
              className="w-full text-xs font-bold py-3 px-4 bg-app-bg border-app-accent shadow-lg" 
            />
          </form>
        )}

        {watchlists.map(list => (
          <div 
            key={list.id} 
            onClick={() => setActiveId(list.id)} 
            className={`group flex justify-between items-center px-4 py-3.5 rounded-xl cursor-pointer transition-all border ${activeId === list.id ? 'bg-app-accent/10 border-app-accent/30 text-app-accent shadow-xl shadow-app-accent/5' : 'hover:bg-white/[0.03] text-app-muted border-transparent hover:border-app-border'}`}
          >
            {editingId === list.id ? (
              <form onSubmit={(e) => handleRename(list, e)} className="flex-1 mr-2" onClick={e => e.stopPropagation()}>
                <input 
                  autoFocus
                  type="text" 
                  value={editName} 
                  onChange={e => setEditName(e.target.value)}
                  onBlur={() => setEditingId(null)}
                  className="w-full text-xs font-bold py-1 bg-app-bg border-app-accent rounded"
                />
              </form>
            ) : (
              <span className="text-xs font-bold uppercase tracking-wider truncate flex-1">{list.name}</span>
            )}
            
            <div className="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity ml-2">
              <button 
                onClick={(e) => startRename(list, e)} 
                className="p-1 hover:text-white transition-colors"
                title="Rename"
              >
                <FiIcons.FiEdit2 size={12} />
              </button>
              <button 
                onClick={(e) => handleDelete(list.id, e)} 
                className="p-1 hover:text-app-red transition-colors"
                title="Delete"
              >
                <FiIcons.FiTrash2 size={12} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}